export * from "./aspect-results.component";
